import Vue from "vue";
import Router from "vue-router";
import { publicRoute, protectedRoute } from "./config";

const routes = publicRoute.concat(protectedRoute);

Vue.use(Router);

const router = new Router({
    mode: "history",
    linkActiveClass: "active",
    routes: routes
});

router.beforeEach((to, from, next) => {
    if (window.$abortController) window.$abortController.abort()
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let hasAthencated = Vue.$cookies.isKey(process.env.VUE_APP_COOKIE_NAME);
        let authencatedCookie = Vue.$cookies.get(process.env.VUE_APP_COOKIE_NAME);
        if (hasAthencated && authencatedCookie !== null) {
            next();
            try {
                if(window.chatTool ==="chatwood"){
                    window.$chatwoot.setCustomAttributes({
                        Current_Link: window.location.href
                    });
                }
            }catch {}
            return;
        }
        next("/login");
    } else {
        next();
        try {
            if(window.chatTool ==="chatwood"){
                window.$chatwoot.setCustomAttributes({
                    Current_Link: window.location.href
                });
            }
        }catch {}
    }
});

export default router;
